import { render } from "./About.vue?vue&type=template&id=d974a13e&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=d974a13e&scoped=true&lang=css"

import exportComponent from "C:\\PRO\\TimeSheet\\vue-cal-dev-ts-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d974a13e"]])

export default __exports__